import { updateMemberSubscription } from 'actions/LuxPlusActions'
import FormatCurrency from 'components/Common/FormatCurrency'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import BodyText from 'LuxKit/Typography/BodyText'
import FormatDateTime from 'components/utils/Formatters/FormatDateTime'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { LUXURY_PLUS } from 'luxPlus/constants/base'
import { useCallback } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

interface Props {
  item: App.MemberSubscriptionItem
  onReactivationSuccess: () => void
  onBack: () => void
}

function LuxPlusManageAccountModalRenewalReactivation({
  item,
  onReactivationSuccess,
  onBack,
}: Props) {
  const intl = useIntl()
  const fetching = useAppSelector(state => state.auth.account.luxPlus.member.subscription.fetching)

  const dispatch = useAppDispatch()
  const resumeMemberSubscription = useCallback(() => {
    dispatch(updateMemberSubscription({ op: 'resume' }))
    onReactivationSuccess()
  }, [dispatch, onReactivationSuccess])

  if (item.nextChargeAttemptDate === undefined || item.currentSubscriptionPrice === undefined) return null

  return <>
    <ModalHeader
      title={intl.formatMessage({
        id: 'ht2Qlfg3hG9Jllk3rivs',
        defaultMessage: 'Re-enable Renewal',
        description: 'Heading title for the re-enable renewal modal in a modal dialog',
      })}
      onBackButtonClick={onBack}
    />
    <ModalBody>
      <ModalContent>
        <LoadingIndicator floating visible={fetching} />
        <BodyText variant="medium">
          <FormattedMessage
            id="_pimGH_Ohs3cZGG-WW6I"
            defaultMessage="By choosing to resume automatic renewal of your {programName} membership, you will be charged the annual subscription fee of {subscriptionFee} on {chargeDate} and continue to enjoy your membership benefits."
            description="Confirmation message for reactivating LuxPlus+ membership renewal with fee and charge date"
            values={{
              programName: LUXURY_PLUS.PROGRAM_NAME,
              subscriptionFee: <FormatCurrency value={item.currentSubscriptionPrice} />,
              chargeDate: <FormatDateTime value={item.nextChargeAttemptDate} dateStyle="medium" />,
            }}
          />
        </BodyText>
      </ModalContent>
    </ModalBody>
    <ModalFooter
      primaryActionProps={{
        children: intl.formatMessage({
          id: 'TZMEDf_m8Td94NYnHhmt',
          defaultMessage: 'Confirm membership renewal',
          description: 'Button text to confirm re-enabling automatic membership renewal',
        }),
        onClick: resumeMemberSubscription,
      }}
    />
  </>
}

export default LuxPlusManageAccountModalRenewalReactivation
